import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const AddProductPlaceholderContainer = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getPurpurSpacing('100')};
    width: 100%;
    height: calc(100% - ${getPurpurSpacing('200')} - ${getPurpurSpacing('200')});
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} dashed ${getPurpurColor('gray300')};
    color: ${getPurpurColor('textInteractivePrimary')};
    font-weight: ${getPurpurTypography('weightMedium')};
    text-decoration: none;
    margin: ${getPurpurSpacing('200')} 0;

    ${purpurFocus()};

    ${purpurMedia('md')`
        width: calc(100% - ${getPurpurSpacing('200')} - ${getPurpurSpacing('200')});
        margin: ${getPurpurSpacing('200')} ${getPurpurSpacing('200')};
    `};
    ${purpurMedia('lg')`
        width: 100%;
        height: 100%;
        margin: 0;
        min-width: 19rem;
    `};

    &:hover {
        color: ${getPurpurColor('textInteractivePrimaryHover')};
        text-decoration: none;
    }
`;
